
import { Radio, Group } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFRadioGroup = ({
  name,
  rules,
  defaultValue = "",
  options = [], // Changed to options to match your usage
  data = [],    // Kept as a fallback just in case
  orientation = "horizontal",
  gap = 'lg',
  onValueChange,
  ...props
}) => {
  const { control } = useFormContext();

  // Use options if provided, otherwise fallback to data
  const radioItems = options.length > 0 ? options : data;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <Radio.Group
          {...props}
          value={field.value ?? ""}
          error={error?.message}
          onChange={(value) => {
            field.onChange(value);

            if (onValueChange) {
              onValueChange(value);
            }
          }}
        >
          {/* Note: Depending on your Mantine version, you might need to adjust orientation/direction here */}
          <Group gap={gap} style={{ flexDirection: orientation === "vertical" ? "column" : "row" }}>
            {radioItems.map((item) => (
              <Radio
                key={item.value}
                value={item.value}
                label={item.label}
                styles={{
                  body: {
                    padding: '14px 24px 14px 16px ',
                    width: 'fit-content ',
                    backgroundColor: '#e8eef7 ',
                    borderRadius: '26px ',
                    marginBottom: '0px ',
                    alignItems:'center '
                  }
                }}
                    color="red"

                 variant="outline"
                disabled={item.disabled}
              />
            ))}
          </Group>
        </Radio.Group>
      )}
    />
  );
};

export default RHFRadioGroup;